<template>
<div class="main-cn">
    <div class="main-hd">
        <h4>系统日志</h4>
    </div>
    <div class="main-bd mg20 pro-visible">
        <el-row class="searchSection" >
            <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                <!-- <el-form-item label="路由">
                    <el-input v-model="searcherModel.route" size="small" placeholder="请输入路由"></el-input>
                </el-form-item> -->
                <el-form-item label="操作时间">
                    <el-date-picker
                    size="small"
                    v-model="searcherModel.created_at"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="业务员" prop="maturity">
                    <UserSelect ref="user" v-model="searcherModel.user_id" @change="UserHandleChange"></UserSelect>
                </el-form-item> 
                <el-form-item label="操作内容" prop="target_class">
                    <el-select v-model="searcherModel.target_class" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="用户信息" value="app\models\User"></el-option>
                        <el-option label="部门信息" value="app\models\Branch"></el-option>
                        <el-option label="职位管理" value="app\models\Role"></el-option>
                        <el-option label="审批流程管理" value="app\models\Flow"></el-option>
                        <el-option label="订单流程配置" value="app\models\OrderFlowConfig"></el-option>
                        <el-option label="地区管理" value="app\models\v2cms\DistrictFunction"></el-option>
                        <el-option label="限制登录" value="app\models\LoginRule"></el-option>
                        <el-option label="解绑规则" value="app\models\Rules"></el-option>
                    </el-select>
                </el-form-item>         
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small" >重置</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-table :data="list" style="width: 100%" class="tabTopBorder" v-loading="loading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-row>
                        <el-col :span="12" v-if="props.row.old_record.length > 0">
                            <div>{{props.row.type_name}}{{props.row.type == 3 ? '前' : ''}}</div>
                            <div v-for="(item, index) in props.row.old_record" :label="item.label + '：'" :key="index">{{ item.label }}：{{ item.value }}</div>
                        </el-col>
                        <el-col :span="12" v-if="props.row.diff_record.length > 0">
                            <div>修改信息</div>
                            <div v-for="(item, index) in props.row.diff_record" :label="item.label + '：'" :key="index" style="color:red;">{{ item.label }}：{{ item.value }}</div>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="操作时间"></el-table-column>
            <!-- <el-table-column prop="id" label="ID"></el-table-column> -->
            <!-- <el-table-column prop="desc" label="描述">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start"
                        title="详情"
                        width="600"
                        >
                    <div><span>{{ scope.row.desc }}</span></div>
                    
                    <div slot="reference" class="name-wrapper">
                        <el-tag >详情</el-tag>
                    </div>
                    </el-popover>
                </template>
            </el-table-column> -->
            <!-- <el-table-column prop="route"  label="路由"></el-table-column> -->
            <!-- <el-table-column prop="record_id" label="操作记录id"></el-table-column> -->
            <el-table-column prop="user" label="操作人"></el-table-column>
            <el-table-column prop="operate_type_name" label="执行操作"></el-table-column>
            <el-table-column prop="model_name" label="操作内容"></el-table-column>
            <el-table-column prop="ip" label="执行ip"></el-table-column>
        </el-table>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
    </div>
</div>
</template>

<script>
import MyPagination from "~/widgets/MyPagination.vue";
import SysLogService from "~/services/syslog";
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import Config from "~/config/params";

export default {
    components: {
        MyPagination,
        CustomerSelect,
        UserSelect,
        Config
    },
    data() {
        return {
            types: {},
            maturity: {},
            searcherModel: {
                route: '',
                user_id: '',
                created_at: Config.getDataTimes('this_week'),
                target_class: '',
            },
            list: [],
            loading: true,
            // 分页信息
            linkPage: null
        };
    },

    // 监听路由参数更新执行分页请求
    // beforeRouteUpdate: function(to, from, next) {
    //     this.getList({
    //         page: to.query["page"],
    //         perPage: to.query["perPage"]
    //     });
    // },

    created: function() {
        this.submitSearch();
    },
    methods: {
        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            let params = this.searcherModel;
            params['perPage'] = newSize;
            this.getList(params);
        },
  
        handleCurrentChange(newPage) {
            let params = this.searcherModel;
            // 处理当前页码变化事件
            params['page'] = newPage;
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SysLogService.index(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        // 筛选查询
        submitSearch() {
            this.getList(this.searcherModel);
        },
        /**@description 组件 */
        //业务员姓名远程搜索组件赋值
        UserHandleChange(object) {
            this.searcherModel.user_id = object.label;
        },

        // 重置筛选表单
        resetForm() {
            this.searcherModel = {
                route: '',
                user_id: '',
                created_at: Config.getDataTimes('this_week'),
                target_class: '',
            };
            this.$refs['user'].reset();
            this.list = [];
            this.submitSearch();
        },        

        handleView(order) {
            this.$router.push({
                path: "/order/view",
                query: {
                    id: order.id
                }
            });
        },

        handleUpdate(customer) {
            this.$router.push({
                path: "/customer/edit",
                query: {
                    id: customer.id
                }
            });
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/views/syslog/list.vue